import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=59360d70"
import script from "./BaseVideo.vue?vue&type=script&lang=js"
export * from "./BaseVideo.vue?vue&type=script&lang=js"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=59360d70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/opt/build/repo/components/base/BaseImage.vue').default})
